import { Libraries } from '@react-google-maps/api';

export const jsApiLoaderLibraries: Libraries = ['marker'];
export const DEFAULT_PIN_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40">
    <path fill="#EA4335" d="M12 0C7.31 0 3.5 3.81 3.5 8.5c0 4.69 7.5 15.5 8.5 15.5s8.5-10.81 8.5-15.5C20.5 3.81 16.69 0 12 0z"/>
    <path fill="#FFFFFF" d="M12 4.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>
  </svg>
`;

export const SELECTED_PIN_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40">
    <path fill="#4285F4" d="M12 0C7.31 0 3.5 3.81 3.5 8.5c0 4.69 7.5 15.5 8.5 15.5s8.5-10.81 8.5-15.5C20.5 3.81 16.69 0 12 0z"/>
    <path fill="#FFFFFF" d="M12 4.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>
    <circle cx="12" cy="12" r="22" stroke="#FFFFFF" stroke-width="3" fill="none"/>
  </svg>
`;

export const DEFAULT_ZOOM = 10;
export const SINGLE_STORE_ZOOM = 12;
export const DEFAULT_OPTIONS: google.maps.MapOptions = {
  disableDefaultUI: false,
};
